import {IGetCheckoutShippingOptionsData} from "@connox/typescript-library/types/checkout/requestHandlers/CheckoutRequestHandler";
import * as React from "react";
import {useTranslation} from "react-i18next";
import {DeliveryTime} from "../../../cart/DeliveryTime/DeliveryTime";
import formatCurrency from "../../../../helpers/formatCurrency";
import {useCheckoutContext} from "../../CheckoutContextProvider/CheckoutContextProvider";

interface IShippingOptionRowProps {
  option: IGetCheckoutShippingOptionsData;
  onShippingChanged: (logisticsTypeId: number) => void;
  selected: boolean;
}
/**
 * single shipping option row
 * @param props
 * @constructor
 */
const ShippingOptionRow: React.FC<IShippingOptionRowProps> = (props) => {
  const {t} = useTranslation("checkout");
  const cart = useCheckoutContext().checkout.cartData;
  const {onShippingChanged, option, selected} = props;
  const {description, logisticsTypeId, name, amount, extra, deliveryDaysMax, deliveryDaysMin} = option;
  // recalculate the shipping cost for netto costs. data doesnt coming  already calculated for netto cart
  const shippingCostFormated = cart.isNet
    ? formatCurrency(Number(amount.amount) / 1.19, cart.currencyCode)
    : amount.formatted;
  const key = `shipping${logisticsTypeId}`;

  return (
    <div key={option.logisticsTypeId} className="SimpleRadioList__Row">
      <label htmlFor={key}>
        <div className="SimpleRadioList__Row__Radio">
          <input
            type="radio"
            name="LogisticsTypeId"
            onChange={() => {
              onShippingChanged(logisticsTypeId);
            }}
            id={key}
            defaultChecked={selected}
          />
        </div>
        <div>
          <div
            dangerouslySetInnerHTML={{
              __html:
                (description !== null ? description : name) +
                ` (${Number(amount.amount) > 0 ? t("zzgl. {{cost}}", {cost: shippingCostFormated}) : t("kostenlos")})`,
            }}
          />
          {extra && (
            <div
              dangerouslySetInnerHTML={{
                __html: extra,
              }}
            />
          )}
          <DeliveryTime min={deliveryDaysMin} max={deliveryDaysMax} />
        </div>
      </label>
    </div>
  );
};

export default ShippingOptionRow;
